// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';
export const parseToken = (accessToken) => {
    if (!accessToken) {
        return;
    }
    try {
        return jwt_decode(accessToken);
    }
    catch (e) {
        console.error('error - parsing token', accessToken, e);
    }
};
//# sourceMappingURL=token.js.map